import React, { useState } from 'react';
import Modal from '../../Modal';
import VerificationCenter from './VerificationCenter';

export default function VerificationCenterModal({
  isOpen,
  onClose,
  onComplete,
  scope = 'seller',
}) {
  const handleComplete = result => {
    onComplete?.(result);
    onClose?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Verification Center"
      size="large"
      className="verification-center-modal"
    >
      <VerificationCenter
        variant="modal"
        scope={scope}
        onComplete={handleComplete}
      />
    </Modal>
  );
}

export function VerificationCenterLauncher({
  label = 'Get verified',
  className = '',
  scope = 'seller',
  onComplete,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`verification-center-launcher ${className}`.trim()}
        onClick={() => setIsOpen(true)}
      >
        {label}
      </button>
      <VerificationCenterModal
        isOpen={isOpen}
        scope={scope}
        onClose={() => setIsOpen(false)}
        onComplete={onComplete}
      />
    </>
  );
}
